import {
  ICaseSearchResult,
  ISearchResultTemplateProps,
} from './BroadSearchDataService';
import './BroadSearch.css';
import './SearchItemTemplate.scss';

const SearchItemTemplate = ({
  case_name,
  results,
  case_source_id,
  start_date,
  end_date,
  my_case,
}: ISearchResultTemplateProps) => (
  <div className='search-item ai-list-item'>
    <div className='search-item__container'>
      <div
        className={`search-item__my-case-flag ${my_case ? 'search-item__my-case-flag--active' : 'search-item__my-case-flag--inactive'}`}
      />
      <div className='search-item__col-wrapper'>
        <div className='search-item__col-left'>
          <div className='search-item__row'>
            <h6 className='search-item__name'>{case_name || 'unnamed'}</h6>
          </div>
          {results.map((result: ICaseSearchResult) => (
            <div key={result.person_id} className='search-item__row'>
              <p className='search-item__caption'>{result.person_name}</p>
            </div>
          ))}
        </div>
        <div className='search-item__col-right'>
          <div className='search-item__row search-item__row--right'>
            <p className='search-item__caption search-item__caption--right'>
              {start_date}
              {end_date === 'Active' ? (
                <strong>&ensp;Active</strong>
              ) : (
                <>
                  {end_date !== 'Inactive' && <>&ndash;</>}
                  {end_date}
                </>
              )}
            </p>
          </div>
          <div className='search-item__row search-item__row--right'>
            <p className='search-item__caption search-item__caption--right'>
              ID&nbsp;{case_source_id}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SearchItemTemplate;
